<template>
    <div :class="['api-error-state', { compact }]">
        <div class="api-error-icon">
            <vue-feather type="wifi-off" :size="compact ? 28 : 44" stroke-width="1.5"></vue-feather>
        </div>
        <h3 class="api-error-title">
            {{ currentLanguage === 'TA' ? 'உள்ளடக்கத்தை ஏற்ற முடியவில்லை' : "Couldn't load content" }}
        </h3>
        <p class="api-error-message">
            {{ currentLanguage === 'TA'
                ? 'ஏதோ தவறு ஏற்பட்டது. உங்கள் இணைய இணைப்பை சரிபார்த்து மீண்டும் முயற்சிக்கவும்.'
                : 'Something went wrong on our end or with your connection. Please try again.' }}
        </p>
        <button class="api-error-retry" @click="onRetry">
            <vue-feather type="refresh-cw" size="15" stroke-width="2"></vue-feather>
            {{ currentLanguage === 'TA' ? 'மீண்டும் முயற்சி' : 'Try again' }}
        </button>
    </div>
</template>

<script>
import { track } from '../utils/analytics';

export default {
    name: 'ApiErrorState',
    inject: {
        languageRef: { from: 'currentLanguage', default: 'EN' }
    },
    props: {
        compact: { type: Boolean, default: false },
        // Identifies which page/section failed in analytics events.
        source: { type: String, default: 'unknown' }
    },
    emits: ['retry'],
    computed: {
        currentLanguage() {
            return this.languageRef || 'EN';
        }
    },
    mounted() {
        track('api_error_shown', {
            source: this.source,
            path: window.location.pathname
        });
    },
    methods: {
        onRetry() {
            track('api_error_retry', {
                source: this.source,
                path: window.location.pathname
            });
            this.$emit('retry');
        }
    }
}
</script>

<style scoped>
.api-error-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 60px 20px;
    color: var(--text-tertiary);
}

.api-error-state.compact {
    padding: 30px 20px;
}

.api-error-icon {
    color: var(--text-tertiary);
    margin-bottom: 16px;
}

.api-error-title {
    color: var(--text-secondary);
    font-size: 20px;
    font-weight: 600;
    margin: 0 0 8px;
}

.api-error-state.compact .api-error-title {
    font-size: 17px;
}

.api-error-message {
    color: var(--text-tertiary);
    font-size: 14px;
    line-height: 1.5;
    max-width: 420px;
    margin: 0 0 20px;
}

.api-error-retry {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: var(--accent-primary);
    color: white;
    border: none;
    padding: 10px 24px;
    border-radius: 25px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
}

.api-error-retry:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px var(--shadow-color);
}
</style>
